import { Switch } from "@mui/material";

import { customNameComparator } from "../../../../../helpers/coappDataGridUtils";
import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridListCell from "../../../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";

export const groupUserColumns = ["actions", "user", "roles", "groups", "status", "lastExtensionHeartbeat", "createdAt"];

export const getGroupUsersColumns = (
	loading,
	organizationSsoStatus,
	handleUserStatusToggle,
	viewUserPage,
	navigationItemReferences,
	groupId,
	stateName,
	removeUserFromGroup,
	currentUserIsCoAppSupport
) => [
	{
		editable: false,
		field: "user",
		flex: 1,
		headerName: "User",
		sortable: true,
		sortComparator: customNameComparator,
		valueGetter: (params) => params.value === "" ? "" : params,
		pinnable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} isUser={true} />}
				isLoading={loading}
			/>

		),
	},
	{
		editable: false,
		field: "roles",
		flex: 1,
		headerName: "Roles",
		sortable: false,
		pinnable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridListCell items={params.value} resource="Roles" />}
				isLoading={loading}
			/>
		),
	},
	{
		disableColumnMenu: true,
		editable: false,
		field: "groups",
		filterable: false,
		sortable: false,
		flex: 1,
		headerName: "Groups",
		pinnable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridListCell items={params.value} resource="Groups" />}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "active",
		width: 90,
		headerName: "Status",
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<Switch
						checked={params.row.active}
						disabled={organizationSsoStatus}
						onChange={() => handleUserStatusToggle(params.row.id, params.row.active === true ? "false" : "true")}
					/>
				}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "lastHeartbeat",
		width: 200,
		headerName: "Last heartbeat",
		pinnable: false,
		sortable: true,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		editable: false,
		field: "createdAt",
		width: 200,
		headerName: "Created",
		pinnable: false,
		valueGetter: (params) => !params ? null : new Date(params),
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "actions",
		flex: .1,
		sortable: false,
		type: "actions",
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div>
						{
							organizationSsoStatus ?
								<ThreeDotMenu
									options={[
										{
											name: "View User",
											optionClickHandler: () => {
												viewUserPage(params, navigationItemReferences.groupNavItemIndex, groupId, stateName);
											},
										},
									]}
								/>
								:
								<ThreeDotMenu
									options={[
										...((!params.row.isCoAppSupport || currentUserIsCoAppSupport) ? [{
											name: "Remove From Group",
											optionClickHandler: () => {
												removeUserFromGroup(params.row.id);
											},
										}] : []),
										{
											name: "View User",
											optionClickHandler: () => {
												viewUserPage(params, navigationItemReferences.groupNavItemIndex, groupId, stateName);
											},
										},
									]}
								/>
						}
					</div>
				}
				isLoading={loading}
			/>
		),
	},
];